import React, { Suspense, lazy } from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { Auth0Provider } from "./authServices/auth0/auth0Service"
import config from "./authServices/auth0/auth0Config.json"
import { IntlProviderWrapper } from "./utility/context/Internationalization"
import { Layout } from "./utility/context/Layout"
import * as serviceWorker from "./serviceWorker"
import { history } from "./history"
import syncManifest from "./utility/pwaManifest"
import { store } from "./redux/storeConfig/store"
import Spinner from "./components/@vuexy/spinner/Fallback-spinner"
import * as firebase from "firebase";
import "./index.scss"
// import "./@fake-db"
import CONFIG from "./config-front"
import { installFetchAuthInterceptor } from "./lib/session"
React.lazy(() => import('./@fake-db'));
const LazyApp = lazy(() => import("./App"))

// Interceptor global: cierra sesión ante cualquier 401/403 de nuestra API.
installFetchAuthInterceptor()

// configureDatabase()

if(CONFIG.useAnalytics !== false){
  firebase.analytics();
}

//Apunta el manifest al portal actual para que "Añadir a la pantalla de inicio"
//cree el acceso directo del portal donde está el usuario y no de la raíz.
syncManifest()
history.listen(location => syncManifest(location.pathname))

ReactDOM.render(
  <Auth0Provider
    domain={config.domain}
    client_id={config.clientId}
    redirect_uri={window.location.origin + process.env.REACT_APP_PUBLIC_PATH}>
    <Provider store={store}>
      <Suspense fallback={<Spinner />}>
        <Layout>
          <IntlProviderWrapper>
            <LazyApp />
          </IntlProviderWrapper>
        </Layout>
      </Suspense>
    </Provider>
  </Auth0Provider>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
